import { createContext } from 'react'

export const EmbedContext = createContext({
  isEmbed: false,
  internalOrgId: null,
  setInternalOrgId: () => { },
  embedOrg: () => { }
})
